const SideButton = ({ className, style }) => (
  <div
    className={`absolute w-[3px] rounded-full ${className}`}
    style={{ background: "linear-gradient(90deg,#55555c,#9c9ca4,#55555c)", ...style }}
    aria-hidden="true"
  />
);

export default function RealisticIPhone({ children, angle = false }) {
  return (
    <div style={{ perspective: 1400 }}>
      <div
        style={angle ? { transform: "rotateY(-12deg) rotateX(4deg)", transformStyle: "preserve-3d" } : {}}
        className="relative"
      >
        <div
          className="relative w-[400px] rounded-[72px] p-[3px]"
          style={{
            background:
              "linear-gradient(150deg,#cfcfd6 0%,#7c7c85 28%,#333338 52%,#8f8f98 76%,#d8d8de 100%)",
            boxShadow: "0 70px 100px -35px rgba(10,10,12,0.55), 0 25px 40px -20px rgba(10,10,12,0.35)",
          }}
        >
          <SideButton className="-left-[4px] top-[150px]" style={{ height: 34 }} />
          <SideButton className="-left-[4px] top-[210px]" style={{ height: 58 }} />
          <SideButton className="-left-[4px] top-[280px]" style={{ height: 58 }} />
          <SideButton className="-right-[4px] top-[220px]" style={{ height: 86 }} />

          <div className="rounded-[69px] bg-black p-[11px]">
            <div className="relative h-[845px] overflow-hidden rounded-[58px] bg-white">
              <div
                className="absolute left-1/2 top-[13px] z-20 h-[32px] w-[124px] -translate-x-1/2 rounded-full bg-black"
                aria-hidden="true"
              />
              {children}
              <div
                className="pointer-events-none absolute inset-0 z-30"
                style={{
                  background:
                    "linear-gradient(115deg, rgba(255,255,255,0.20) 0%, rgba(255,255,255,0.05) 18%, transparent 32%)",
                }}
                aria-hidden="true"
              />
            </div>
          </div>
        </div>

        <div
          className="absolute -bottom-14 left-1/2 h-10 w-[74%] -translate-x-1/2 rounded-full"
          style={{ background: "rgba(10,10,12,0.35)", filter: "blur(28px)" }}
          aria-hidden="true"
        />
      </div>
    </div>
  );
}
